import { useRef, useLayoutEffect, useCallback } from 'react';

export function useEffectEvent<TArgs extends unknown[], TResult>(
  handler: (...args: TArgs) => TResult
): (...args: TArgs) => TResult {
  const handlerRef = useRef<typeof handler | null>(null);

  useLayoutEffect(() => {
    handlerRef.current = handler;
  });

  return useCallback((...args: TArgs): TResult => {
    const fn = handlerRef.current;

    if (!fn) {
      throw new Error('useEffectEvent callback called before initialization');
    }
    return fn(...args);
  }, []);
}
